// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__9+JwE","navtitle":"navbar_navtitle__1boMJ"};